import {
  StyledMedicalContent,
  StyledMedicalContentLabel,
} from "../MedicalHistory.styled";
import { type IMedicalInput } from "../sections/MedicalSections.model";
import MedicalInput from "./MedicalInput";

const MedicalInputGroup = ({ inputs }: { inputs: IMedicalInput[] }) => {
  return (
    <div style={{ display: "flex", gap: "5px", flexDirection: "column" }}>
      {inputs.map(input => (
        <StyledMedicalContent
          key={input.name}
          style={{ justifyContent: "space-between", alignItems: "center" }}>
          <StyledMedicalContentLabel>{input.label}:</StyledMedicalContentLabel>
          <MedicalInput {...input} />
        </StyledMedicalContent>
      ))}
    </div>
  );
};
export default MedicalInputGroup;
